export default function (store, { targetId, parent, project, reverse }) {
    const copiedTasksId = store.pasteTask({
        targetId,
        parent,
        project,
        reverse,
    });
    return () => {
        for (let i = 0; i < copiedTasksId.length; i++) {
            if (i === 0) {
                store.in.exec("delete-task", {
                    id: copiedTasksId[i],
                    batch: copiedTasksId,
                    $meta: { skipHistory: true },
                });
            }
            else {
                store.in.exec("delete-task", {
                    id: copiedTasksId[i],
                    skipProvider: true,
                    $meta: { skipHistory: true },
                });
            }
        }
    };
}
//# sourceMappingURL=paste.js.map